// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReIjfC3DUYRD3d {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tSbu8stkqFJTb8 {
  flex-grow: 0;
  padding-top: 40px;
}
.DMDpGE43xMmMTi {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 24px 0;
}
.EWbUF7NR4pjDeJ {
  margin: 0;
  color: var(--ds-text-subtle, #44546f);
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TemplateGalleryContentErrorContainer": `ReIjfC3DUYRD3d`,
	"errorPageImage": `tSbu8stkqFJTb8`,
	"errorMessageContainer": `DMDpGE43xMmMTi`,
	"errorMessage": `EWbUF7NR4pjDeJ`
};
export default ___CSS_LOADER_EXPORT___;
